import { ValueOf } from '~types/common';

export const MENU_TYPE_OBJ = {
  DALIY_VIEW_RANK: 'DALIY_VIEW_RANK',
  SALARY_RANK: 'SALARY_RANK',
  PUBLIC_SALARY_RANK: 'PUBLIC_SALARY_RANK',
  RECENT_SALARY_RANK: 'RECENT_SALARY_RANK',
} as const;

export type MENU_TYPE = ValueOf<typeof MENU_TYPE_OBJ>;
